<template>
  <svg class="tooth">
    <g :transform="`translate(${positionX + 2.5}, ${positionY - 5})`">
      <!-- Primer rectángulo -->
      <rect
        width="8"
        height="8"
        x="0"
        y="0"
        stroke="navy"
        fill="white"
        stroke-width="0.5"
      />
      <text
        x="3.75"
        y="5"
        text-anchor="middle"
        dominant-baseline="middle"
        font-size="4"
        fill="black"
      >
        EM
      </text>

      <!-- Segundo rectángulo -->
      <rect
        width="8"
        height="8"
        x="9.5"
        y="0"
        stroke="navy"
        fill="white"
        stroke-width="0.5"
      />
      <text
        x="13.25"
        y="5"
        text-anchor="middle"
        dominant-baseline="middle"
        font-size="4"
        fill="black"
      >
        RX
      </text>

      <!-- Tercer rectángulo -->
      <rect
        width="18.5"
        height="8"
        x="0"
        y="9.5"
        stroke="navy"
        fill="white"
        stroke-width="0.5"
      />
      <text
        x="8.75"
        y="13"
        text-anchor="middle"
        dominant-baseline="middle"
        font-size="4"
        fill="black"
      >
        CUELLO
      </text>
    </g>

    <g :transform="translate">
      <polygon
        points="0,0 20,0 15,5 5,5"
        :class="getClassNamesByZone('top')"
        @click="openContextMenu($event, 'top')"
      />
      <polygon
        points="5,15 15,15 20,20 0,20"
        :class="getClassNamesByZone('bottom')"
        @click="openContextMenu($event, 'bottom')"
      />
      <polygon
        points="15,5 20,0 20,20 15,15"
        :class="getClassNamesByZone('left')"
        @click="openContextMenu($event, 'left')"
      />
      <polygon
        points="0,0 5,5 5,15 0,20"
        :class="getClassNamesByZone('right')"
        @click="openContextMenu($event, 'right')"
      />
      <polygon
        points="5,5 15,5 15,15 5,15"
        :class="getClassNamesByZone('center')"
        @click="openContextMenu($event, 'center')"
      />
      <text
        x="6"
        y="30"
        stroke="navy"
        fill="navy"
        stroke-width="0.1"
        class="tooth"
      >
        {{ number }}
      </text>
      <g
        v-if="toothStateFromStore.Extract > 0"
        :stroke="toothStateFromStore.Extract === 1 ? 'red' : 'blue'"
      >
        <line x1="0" y1="0" x2="20" y2="20" stroke-width="2" />
        <line x1="0" y1="20" x2="20" y2="0" stroke-width="2" />
      </g>
      <g
        v-if="toothStateFromStore.Filter > 0"
        :stroke="toothStateFromStore.Filter === 1 ? 'red' : 'blue'"
      >
        <line x1="0" y1="20" x2="10" y2="0" stroke-width="2" />
        <line x1="20" y1="20" x2="10" y2="0" stroke-width="2" />
        <line x1="0" y1="20" x2="20" y2="20" stroke-width="2" />
      </g>

      <g
        v-if="toothStateFromStore.Fracture > 0"
        :stroke="toothStateFromStore.Fracture === 1 ? 'red' : 'blue'"
      >
        <line x1="0" y1="10" x2="20" y2="10" stroke-width="2" />
      </g>

      <g
        v-if="toothStateFromStore.Sellante > 0"
        :stroke="toothStateFromStore.Sellante === 1 ? 'red' : 'blue'"
      >
        <!-- Línea vertical -->
        <line x1="10" y1="0" x2="10" y2="20" stroke-width="2" />

        <!-- Diagonal ↘ -->
        <line x1="0" y1="0" x2="20" y2="20" stroke-width="2" />

        <!-- Diagonal ↙ -->
        <line x1="0" y1="20" x2="20" y2="0" stroke-width="2" />
      </g>

      <g
        v-if="toothStateFromStore.Crown > 0"
        :stroke="toothStateFromStore.Crown === 1 ? 'red' : 'blue'"
      >
        <!-- Cuadrado externo -->
        <rect x="0" y="0" width="20" height="20" stroke-width="1" />

        <!-- Cuadrado medio -->
        <rect x="4" y="4" width="12" height="12" stroke-width="1" />

        <!-- Cuadrado interno pequeño -->
        <rect x="7" y="7" width="6" height="6" stroke-width="1" />
      </g>
    </g>
    <g :transform="`translate(${positionX + 25}, ${positionY + 20})`">
      <circle
        @click="openContextMenu($event, 'supernumerario')"
        r="4.5"
        cx="1"
        cy="10"
        fill="white"
        stroke="black"
        stroke-width="0.5"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "Tooth",
  props: {
    number: Number,
    positionX: Number,
    positionY: Number,
  },

  data() {
    return {
      menuVisible: false,
      currentZone: null,
      contextMenuStyle: {},
      firstUpdate: true,
    };
  },
  computed: {
    isRoundedTooth() {
      return this.number >= 55 && this.number <= 75;
    },
    translate() {
      return `translate(${this.positionX},${this.positionY + 20})`;
    },

    toothStateFromStore() {
      return (
        this.$store.state.odontologia.toothStates.find(
          (t) => t.id === this.number
        ) || {
          Cavities: {
            center: 0,
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
          },
          Extract: 0,
          Crown: 0,
          Filter: 0,
          Fracture: 0,
          Sellante: 0,
        }
      );
    },
  },

  methods: {
    generarToken(diente, zona) {
      const timestamp = Date.now();
      const random = Math.floor(Math.random() * 100000);
      return `${diente}_${zona}_${timestamp}_${random}`;
    },
    enviarSupernumerario() {
      let dataTooth = {
        number: "supernumerario",
        zone: "-",
      };
    },
    getClassNamesByZone(zone) {
      const state = this.toothStateFromStore.Cavities?.[zone];
      if (state === 1) return "to-do";
      if (state === 2) return "done";
      if (state === 4) return "done-other";

      return "";
    },

    async openContextMenu(event, zone) {
      let diente = this.number;

      let dataTooth = {
        number: diente,
        zone: zone,
        token: this.generarToken(diente, zone),
      };

      if (zone === "supernumerario") {
        dataTooth = {
          number: zone,
          zone: zone,
          token: this.generarToken(zone, zone),
        };
      }

      this.$store.commit("setDataTooth", dataTooth);
    },
  },
};
</script>

<style scoped>
@import "./Tooth.css";
/* @import 'contextmenu/ContextMenu.css';*/

.context-menu {
  background-color: white;
  border: 1px solid #ccc;
  font-size: 14px;
  position: fixed;
  padding: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.context-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.context-menu li {
  padding: 4px 10px;
  cursor: pointer;
}

.context-menu li:hover {
  background-color: #eee;
}

.context-menu .separator {
  border-top: 1px solid #ddd;
  margin: 4px 0;
}
</style>
